import LeangapLogo from '@/components/public/LeangapLogo'

const currentYear = new Date().getFullYear()
const ContactUsLink = 'https://www.leangap.org/contact'
const PrivacyPolicyLink = 'https://www.leangap.org/privacy'
const TermsAndConditionsLink = 'https://www.leangap.org/terms'

export default function Footer() {
	return (
		<footer className="bg-foreground-50 z-0">
			<div className="text-foreground-800 container mx-auto flex flex-wrap items-center justify-center p-4 md:justify-between">
				<a className="inline-block" href="/" title="Leangap">
					<div className="my-2 w-28">
						<LeangapLogo width={112} />
					</div>
				</a>
				<nav>
					<ul className="text-tiny text-center">
						<li className="my-2 inline-block">
							<a
								className="border-default-400 border-r-1 px-2"
								href={ContactUsLink}
								title="Contact us"
								target="_blank"
								rel="noopener noreferrer"
							>
								Contact us
							</a>
						</li>
						<li className="my-2 inline-block">
							<a
								className="border-default-400 border-r-1 px-2"
								href={PrivacyPolicyLink}
								title="Privacy Policy"
								target="_blank"
								rel="noopener noreferrer"
							>
								Privacy Policy
							</a>
						</li>
						<li className="my-2 inline-block">
							<a
								className="border-default-400 border-r-1 px-2"
								href={TermsAndConditionsLink}
								title="Terms & Conditions"
								target="_blank"
								rel="noopener noreferrer"
							>
								Terms & Conditions
							</a>
						</li>
						<li className="my-2 inline-block">
							<p
								className="text-foreground-400 px-2"
								title={`© ${currentYear} Leangap Education, Inc. All rights reserved.`}
							>
								© {currentYear} Leangap Education, Inc. All rights reserved.
							</p>
						</li>
					</ul>
				</nav>
			</div>
		</footer>
	)
}
